/* Lumi-noble header behaviour (pairs with assets/lumi-nav.css)
   - scroll state: .lumi-nav--scrolled (+ theme's .scrolled-past-header so the
     transparent home header turns solid)
   - mobile: hide on scroll down, show on scroll up (.lumi-nav--hidden)
   - drawer: accordion submenus instead of MenuDrawer's slide-in panels */
(function () {
  var section = document.querySelector('.shopify-section-header');
  if (!section || !section.querySelector(':scope > .lumi-nav')) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var drawer = section.querySelector('header-drawer');
  var drawerToggle = drawer && drawer.querySelector(':scope > details');
  var lastY = window.scrollY;
  var ticking = false;
  var HIDE_AFTER = 160;

  function menuIsOpen() {
    return (
      (drawerToggle && drawerToggle.hasAttribute('open')) ||
      section.querySelector('.details--list-menu[open], details-modal details[open], .disclosure__button[aria-expanded="true"]')
    );
  }

  function update() {
    ticking = false;
    var y = Math.max(window.scrollY, 0);
    var scrolled = y > 8;

    section.classList.toggle('lumi-nav--scrolled', scrolled);
    section.classList.toggle('scrolled-past-header', scrolled);

    var hidden = section.classList.contains('lumi-nav--hidden');
    if (desktop.matches || menuIsOpen() || y <= HIDE_AFTER) {
      hidden = false;
    } else if (y > lastY + 4) {
      hidden = true;
    } else if (y < lastY - 4) {
      hidden = false;
    }
    section.classList.toggle('lumi-nav--hidden', hidden);
    lastY = y;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  desktop.addEventListener('change', update);
  update();

  if (!drawer || !drawerToggle) return;

  // The drawer is positioned from the top of the sticky header; size it to
  // whatever is left of the viewport when it opens.
  drawerToggle.addEventListener('toggle', function () {
    if (!drawerToggle.hasAttribute('open')) return;
    section.classList.remove('lumi-nav--hidden');
    var top = Math.max(section.getBoundingClientRect().top, 0);
    document.documentElement.style.setProperty('--lumi-drawer-top', top + 'px');
  });

  // Accordion: stop MenuDrawer.onSummaryClick (slide-in + focus trap) for
  // submenu summaries and let the native <details> toggle do the work.
  drawer.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest('summary');
      if (!summary || !drawer.contains(summary)) return;
      var details = summary.parentElement;
      if (details === drawerToggle) return;

      event.stopPropagation();

      if (!details.hasAttribute('open')) {
        var list = details.closest('ul');
        if (list) {
          list.querySelectorAll(':scope > li > details[open]').forEach(function (other) {
            if (other !== details) {
              other.removeAttribute('open');
              other.classList.remove('menu-opening');
            }
          });
        }
      }
    },
    true
  );

  drawer.querySelectorAll('details').forEach(function (details) {
    if (details === drawerToggle) return;
    details.addEventListener('toggle', function () {
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', details.hasAttribute('open'));
      if (!details.hasAttribute('open')) details.classList.remove('menu-opening');
    });
  });
})();
